import { CarbonSectionData, CarbonSectionInputData } from "./CarbonSection";

export const initialCarbonSectionData: CarbonSectionData = {
    CarSection: {
        FuelType: null,
        Type: "",
        Unit: "km",
        Value: "",
        Complete: false,
        InspectionId: undefined
    } as CarbonSectionInputData,
    TrainSection: {
        FuelType: null,
        Type: "",
        Unit: "km",
        Value: "",
        Complete: false,
        InspectionId: undefined
    } as CarbonSectionInputData,
    AeroplaneSection: {
        FuelType: null,
        Type: "",
        Unit: "km",
        Value: "",
        Complete: false,
        InspectionId: undefined
    } as CarbonSectionInputData,
    Complete: false,
    inspectionId: undefined
};
